import type { AppRouteRecordRaw } from '@/router/types';
import { EXCEPTION_COMPONENT, FORBIDDEN_COMPONENT, PAGE_NOT_FOUND_NAME } from '@/router/constant';
import { ExceptionEnum } from '@/enums/exceptionEnum';

// 403 单独页面
export const FORBIDDEN_ROUTE: AppRouteRecordRaw = {
  path: '/403',
  name: 'Forbidden',
  component: FORBIDDEN_COMPONENT,
  meta: {
    title: 'Forbidden',
    hideBreadcrumb: true,
    hideMenu: true
  }
};

export const EXCEPTION_ROUTE: AppRouteRecordRaw = {
  path: '/exception/:type(\\d+)',
  name: 'ExceptionPage',
  component: EXCEPTION_COMPONENT,
  meta: {
    title: 'ExceptionPage',
    hideBreadcrumb: true,
    hideMenu: true
  }
};

export const EXCEPTION_REDIRECT_ROUTE: AppRouteRecordRaw = {
  path: '/exception',
  name: 'ExceptionRedirect',
  redirect: `/exception/${ExceptionEnum.PAGE_NOT_ACCESS}`,
  meta: {
    title: 'ExceptionPage',
    hideBreadcrumb: true,
    hideMenu: true
  }
};

// 404 on a page
export const PAGE_NOT_FOUND_ROUTE: AppRouteRecordRaw = {
  path: '/:path(.*)*',
  name: PAGE_NOT_FOUND_NAME,
  redirect: '/login',
  meta: {
    title: 'ErrorPage',
    hideBreadcrumb: true,
    hideMenu: true,
    status: ExceptionEnum.PAGE_NOT_FOUND
  }
};
